<script>
	export default {
		props: {
			data: {
				type: Array,
				required: true
			}
		}
	};
</script>

<template>
	<div 
		class="modal fade" 
		id="modal-mis-reconocimientos"
		tabindex="-1"
		>
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header d-flex justify-content-between border-0 pb-0">
					<h5 class="modal-title font-700 text-secondary">
						Número de reconocimientos
					</h5>
					<a 
					class="h3 mb-0 link-secondary" 
					href="javascript:"
					data-bs-dismiss="modal"
					>
					<font-awesome-icon icon="fa-solid fa-xmark"></font-awesome-icon>
					</a>
				</div>
				<div class="modal-body">
					<ul class="list-group list-group-flush">
						<li 
							v-for="item in data"
							:key="item.id_valor"
							class="list-group-item text-secondary d-flex justify-content-between">
							{{ item.nombre_valor }}
							<span class="text-secondary d-flex align-items-center">
								<span class="circle-text me-1" :style="`background-color: #${item.color}`"></span>
								{{ item.count }}
							</span>
						</li>
					</ul>
				</div>
				<div class="modal-footer">
					<button 
						type="button" 
						class="btn btn-custom btn-custom-line-gray w-100" 
						data-bs-dismiss="modal">
						<font-awesome-icon icon="fa-solid fa-angle-left" class="pe-2"></font-awesome-icon>
						Volver
					</button>
				</div>
			</div>
		</div>
	</div>

</template>